import { render, staticRenderFns } from "./LoginHome.vue?vue&type=template&id=4adddb98&"
import script from "./LoginHome.vue?vue&type=script&lang=js&"
export * from "./LoginHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports